import { t } from '@/i18n';
import styles from './DesktopResultAside.module.css';

export function DesktopResultAside() {
  return (
    <aside className={styles.stack}>
      <div className={styles.note}>
        <span className={styles.pin} aria-hidden>
          {String.fromCodePoint(0x1f4cc)}
        </span>
        <span>{t.result.aside.savedNote}</span>
      </div>
    </aside>
  );
}
